module.exports = __webpack_public_path__ + "static/CAPExbg-f160c915ca9043a6db3a1df3aeb614c0.jpg";